import React from 'react';
import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from './contexts/UserContext';

import AdminLayout from './components/Admin/AdminLayout'; 
import ClientLayout from './components/Client/ClientLayout'; 

import Plats from './components/Admin/gestion_plats/Plats';
import AddPlat from './components/Admin/gestion_plats/AddPlat';
import Commandes from './components/Admin/gestion_commandes/Commandes';
import Categories from './components/Admin/gestion_categories/Categories';
import Addons from './components/Admin/gestion_addons/Addons';
import Permissions from './components/Admin/gestion_users/Permissions';
import Roles from './components/Admin/gestion_users/Roles';
import Users from './components/Admin/gestion_users/Users';
import Panier from './components/Admin/gestion_panier/Panier';
import HorairesOuverture from './components/Admin/gestion_horaires/HorairesOuverture';
import JoursFermeture from './components/Admin/gestion_horaires/JoursFermeture';
import Emails from './components/Admin/gestion_emails/Emails';
import Reservations from './components/Admin/gestion_reservations/Reservations';

import AddPromo from './components/Admin/gestion_promo/AddPromo';
import Promos from './components/Admin/gestion_promo/Promos';
import Boutique from './components/Client/Boutique';
import Construction_page from './components/Client/Construction_page';
import Checkout from './components/Client/Checkout';
import ClientPanier from './components/Client/Panier';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import GerantProtectedRoute from './components/GerantProtectedRoute';
import Login from './pages/Login';
import AccessDenied from './pages/AccessDenied';
import NotFound from './pages/NotFound';

function App() { 
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
        
          {/* Client Routes */}
          <Route path="/" element={<ClientLayout />}>
            <Route index element={<Navigate to="/Construction_page" />} />

            <Route path="/Construction_page" element={<Construction_page />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/panier" element={<ClientPanier />} />
            <Route path="/login" element={<Login />} />
            <Route path="/accessDenied" element={<AccessDenied />} />
              {/* Route 404 (toujours en dernier) */}
            <Route path="*" element={<NotFound />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }>
            <Route index element={<Commandes />} />
            <Route path="plats" element={<Plats />} />
            <Route path="addPlat" element={<AddPlat />} />
            <Route path="categories" element={<Categories />} />
            <Route path="addons" element={<Addons />} />
            <Route path="permissions" element={<Permissions />} />
            <Route path="roles" element={<Roles />} />
            <Route path="users" element={<Users />} />
            <Route path="panier" element={<Panier />} />
            <Route path="promos" element={<Promos />} />
            <Route path="add-promo" element={<AddPromo />} />
            <Route path="horairesOuverture" element={<HorairesOuverture />} />
            <Route path="JoursFermeture" element={<JoursFermeture />} />
            <Route path="Email" element={<Emails />} />
            <Route path="Reservations" element={<Reservations />} />
          </Route>

          {/* Gerant Routes */}
          <Route path="/gerant" element={
            <GerantProtectedRoute>
              <AdminLayout />
            </GerantProtectedRoute>
          }>
            <Route index element={<Commandes />} />
            <Route path="plats" element={<Plats />} />
            <Route path="categories" element={<Categories />} />
            <Route path="addons" element={<Addons />} />
            <Route path="permissions" element={<Permissions />} />
            <Route path="roles" element={<Roles />} />
            <Route path="users" element={<Users />} />
            <Route path="panier" element={<Panier />} />
            <Route path="promos" element={<Promos />} />
            <Route path="horairesOuverture" element={<HorairesOuverture />} />
            <Route path="JoursFermeture" element={<JoursFermeture />} />
            <Route path="Email" element={<Emails />} />
            <Route path="Reservations" element={<Reservations />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
